export const paths = [{ "tag": "path", "att": { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "m13.0037 16.1727 5.5869-5.5862 1.4141 1.4144-8.0011 8-8.0007-8.0013 1.4143-1.4141 5.5865 5.5869V4h2v12.1727z" } }];
export const iconName = 'arrow-down';
export const arrowDown = { iconName, paths };
export default paths;
